export default __webpack_public_path__ + "static/media/sponsor_block_2.03f74fa0.webp";